export const getPath = (...rest: any[]) => {
    const apiUrl: string[] = rest.map(value => {
        if (value.query) {
            const queryString = Object.keys(value.query)
                .map((key) => `${key}=${value.query[key]}`)
                .join("&");
            return `?${queryString}`;
        }
        return value;
    })
    return [''].concat(apiUrl).join('/').replace('/?', "?");
}